import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Bin } from '../../../webcommon/common/Icons/Bin.svg';
import { noop } from 'lodash';
import defaulStyles from './SelectRow.module.scss';

const SelectRow = (props) => {
    const { selectTemplate, row, deleteRow } = props;
    const selectItem = useCallback(() => {
        selectTemplate(row);
    }, [selectTemplate, row]);

    const deleteRowFunc = useCallback(() => {
        deleteRow(row);
    }, [deleteRow, row]);
    return (
        <div className={ props.styles.selectRow }>
            <div className={ props.styles.selectRowText }>
                <button
                    type="button"
                    onClick={ selectItem }
                    className={ props.styles.selectText }
                >
                    {props.row}
                </button>
            </div>
            <button
                type="button"
                onClick={ deleteRowFunc }
                className={ props.styles.delete }
            >
                <Bin />
            </button>
        </div>
    );
};

SelectRow.propTypes = {
    deleteRow: PropTypes.func,
    row: PropTypes.string,
    selectTemplate: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string)
};

SelectRow.defaultProps = {
    deleteRow: noop,
    selectTemplate: noop,
    row: '',
    styles: defaulStyles
};

export default SelectRow;
